export const JOURNEY_TYPES = {
  filter: 'Filtering',
  enrichment: 'Enrichment',
} as const;
